<template>
    <div>
        <div class="template__grid" :style="fatherIsWhiteLabel ? 'grid-template-columns: 100% !important' : ''">
            <div class="left__content" v-if="!fatherIsWhiteLabel">
                <div class="balance">
                    <card-delete class="card__content">
                        <div v-if="AccountValues != null" :slot="'card_content'" class="card__structure card__balance">
                            <div v-for="(values, key) in AccountValues" :key="key" class="align__right" :class="values.name">
                                <div v-for="(val, key) in values.data" :key="key" class="balance">
                                    <span class="symbol mright">{{ currencySymbol(val.Moeda.toLowerCase()) }}</span>
                                    <span class="value mright">{{ val.Soma }}</span>
                                </div>
                                <span class="translation mright">{{ values.translation }}</span>
                                <hr v-if="key < 2">
                            </div>
                        </div>
                        <div v-else :slot="'card_content'" class="card__structure ndata">
                            {{ view.translation.no_data_show }}
                        </div>
                    </card-delete>
                </div>
                <div class="leads">
                    <card-delete class="card__content">
                        <div v-if="view.total_leads.length > 0" :slot="'card_content'" class="card__structure">
                            <div class="top_total_lead">
                                <div class="lead_component">
                                    <span class="total_leads_label">{{ view.translation.label_total_leads + ':' }}</span>
                                    <span class="total_leads">{{ view.total_leads.length }}</span>
                                </div>
                                <lead-carousel
                                    key="filter"
                                    :view="view.total_leads"
                                    class="carousel"
                                >
                                    <div
                                        class="slide-wrapper"
                                        :slot="'slide'"
                                        slot-scope="props"
                                        :class="props.slideClass"
                                    >
                                        <div class="card_peopple"
                                        >
                                            <img :src="props.slide.img_user" alt="Image not found" />
                                            <span>{{ props.slide.name_user.match(/^[^\s]+/).shift() }}</span>
                                        </div>
                                    </div>
                                </lead-carousel>
                            </div>
                        </div>
                        <div v-else :slot="'card_content'" class="card__structure ndata">
                            {{ view.translation.no_data_show }}
                        </div>
                    </card-delete>
                </div>
                <div class="graphic">
                    <card-delete class="card__content">
                        <div :slot="'card_content'" class="card__structure">
                            <div class="option__graphic">
                                <button class="btn_select_graphic" :class="{ 'lead': btnActive == 'lead' }" @click="changeCraphic('lead')">
                                    <span class="text">{{ view.translation.label_total_leads_mes }}</span>
                                    <span class="underline"></span>
                                </button>
                                <button class="btn_select_graphic" :class="{ 'franchise': btnActive == 'franchise' }" @click="changeCraphic('franchise')">
                                    <span class="text">{{ view.translation.label_historico_franquia }}</span>
                                    <span class="underline"></span>
                                </button>
                            </div>
                            <div class="graphics__structure">
                                <div class="parent__gaphic">
                                    <bar-chart
                                        v-if="btnActive == 'lead'"
                                        key="lead"
                                        :chartData="{
                                            labels: chartData.months,
                                            datasets: [
                                                {
                                                  label: view.translation.label_affiliated_total_leads,
                                                  backgroundColor: '#156CDD',
                                                  data: chartData.data,
                                                  barPercentage: 0.666666667,
                                                  categoryPercentage: 0.32
                                                }
                                            ]
                                        }"
                                        :options="{
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            cornerRadius: 2,
                                            fullCornerRadius: true,
                                            legend: {
                                                align: 'start',
                                                display: false,
                                                labels: {
                                                    boxWidth: 10,
                                                    fontFamily: 'Lato',
                                                    fontSize: 14,
                                                    fullWidth: false
                                                }
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        min: chartOptions.min,
                                                        stepSize: chartOptions.stepSize,
                                                    }
                                                }]
                                            }
                                        }"
                                        :styles="{ // parent node
                                            position: 'relative',
                                            width: '100%',
                                            height: 'auto',
                                            padding: '1rem',
                                        }"
                                        :width="534"
                                        :height="330"
                                    />
                                    <bar-chart
                                        v-else-if="btnActive == 'franchise'"
                                        key="franchise"
                                        :chartData="{
                                            labels: view.statusFranquiaLabel,
                                            datasets: [
                                                {
                                                  label: view.translation.label_affiliated_total_leads,
                                                  backgroundColor: '#156CDD',
                                                  data: chartFranquia.data,
                                                  barPercentage: 0.666666667,
                                                  categoryPercentage: 0.32
                                                }
                                            ]
                                        }"
                                        :options="{
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            cornerRadius: 2,
                                            fullCornerRadius: true,
                                            legend: {
                                                align: 'start',
                                                display: false,
                                                labels: {
                                                    boxWidth: 10,
                                                    fontFamily: 'Lato',
                                                    fontSize: 14,
                                                    fullWidth: false
                                                }
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        min: chartOptions.min,
                                                        stepSize: chartOptions.stepSize,
                                                    }
                                                }]
                                            }
                                        }"
                                        :styles="{ // parent node
                                            position: 'relative',
                                            width: '100%',
                                            height: 'auto',
                                            padding: '1rem',
                                        }"
                                        :width="534"
                                        :height="330"
                                    />
                                </div>
                            </div>
                        </div>
                    </card-delete>
                </div>
            </div>
            <div :class="['right__content',fatherIsWhiteLabel ? 'iswl' : '']">
                <div class="msg__delete">
                    <card-delete class="card__content">
                        <div :slot="'card_content'" class="card__structure" :style="fatherIsWhiteLabel ? 'display: flex; align-items: center; justify-content: center; max-width: none !important;' : ''">
                            <div class="component_align_center">
                                <p class="title_component" v-html="view.translation.label_title"></p>
                            </div>
                        </div>
                    </card-delete>
                </div>
                <div class="select__delete">
                    <card-delete class="card__content">
                        <div :slot="'card_content'" class="card__structure" :style="fatherIsWhiteLabel ? 'display: flex; align-items: center; justify-content: center; max-width: none !important;' : ''">
                            <div class="component_form" v-if="!fatherIsWhiteLabel">
                                <p class="title_form">{{ view.translation.label_feedbak }}</p>
                                <form method="post" id="form__delete">
                                    <p v-for="question in questions">
                                        <label class="container">{{question.description}}
                                            <input type="checkbox" name="checkedCategories[]" :value="question.id" v-model="checkedCategories" />
                                            <span class="checkmark" />
                                        </label>
                                    </p>
                                    <span class="input_another">
                                        <span>{{ view.translation.label_another }}</span>
                                        <!-- <input type="text" class="validate" :placeholder="view.translation.label_another" name="outro" v-model="outro"> -->
                                        <textarea name="outro" lass="validate" :placeholder="view.translation.label_another" v-model="outro" rows="3"></textarea>
                                    </span>
                                    <span class="input_another">
                                        <span>{{ view.translation.dns_confirm_your_password }}</span>
                                        <input type="password" class="validate" :placeholder="view.translation.senha" name="password" v-model="password" required>
                                    </span>
                                    <div class="btn_form_structure">
                                        <btn-delete :isBtn="false" :view="view.translation.external_auth_cancel" :value="'grey'" :anchor="view.handler_routes.rota_office_index"></btn-delete>
                                        <btn-delete :isBtn="true" :view="view.translation.label_delete_account" :value="'red'" :propFunction="openModal"></btn-delete>
                                    </div>
                                </form>
                            </div>
                            <div class="component_form" v-else>
                              <form method="post" id="form__delete" style="width:30rem;">
                                    <span class="input_another">
                                        <span>{{ view.translation.dns_confirm_your_password }}</span>
                                        <input type="password" class="validate" :placeholder="view.translation.senha" name="password" v-model="password" required>
                                    </span>
                                    <div class="btn_form_structure">
                                        <btn-delete :isBtn="false" :view="view.translation.external_auth_cancel" :value="'grey'" :anchor="view.handler_routes.rota_office_index"></btn-delete>
                                        <btn-delete :isBtn="true" :view="view.translation.label_delete_account" :value="'red'" :propFunction="openModal"></btn-delete>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </card-delete>
                </div>
            </div>
        </div>
        <div v-if="showModal != 0" class="modal__overlay">
            <div class="modal__structure" v-if="showModal == 1" >
                <div class="modal__header">
                    <span class="atention__text">{{ view.translation.attention_ba_wl_plans }}</span>
                </div>
                <div class="modal__body">
                    <p><span class="_text">{{ view.translation.dismiss_commission_text_one }}</span></p>
                    <p><span class="_text">{{ view.translation.dismiss_commission_text_two }}</span></p>
                </div>
                <div class="modal__footer">
                    <btn-delete :isBtn="false" :view="view.translation.label_ver_ganhos" :value="'blue'" :anchor="view.handler_routes.rota_office_franchise_system_earn"></btn-delete>
                    <btn-delete :isBtn="true" :view="view.translation.dismiss_commission" :value="'red'" :propFunction="dimissComission"></btn-delete>
                </div>
            </div>
            <div class="modal__structure second__modal" v-if="showModal == 2" >
                <div class="modal__header">
                    <span class="title__text">{{ view.translation.mail_delete_title }}</span>
                </div>
                <div class="modal__body">
                    <li><span class="_text">{{ view.translation.precautionary_p1 }}</span></li>
                    <li v-if="!fatherIsWhiteLabel"><span class="_text">{{ view.translation.precautionary_p2 }}</span></li>
                    <li><span class="_text">{{ view.translation.precautionary_p3 }}</span></li>
                    <li><span class="_text">{{ view.translation.precautionary_p4 }}</span></li>
                    <li><span class="_text">{{ view.translation.precautionary_p5 }}</span></li>
                    <div style="margin-top: 1rem">
                        <p><span class="_text first_text">{{ view.translation.precautionary_p6 }}</span></p>
                        <p v-if="!fatherIsWhiteLabel"><span class="_text">{{ view.translation.precautionary_p7 }}</span></p>
                        <p><span class="_text">{{ view.translation.precautionary_p8 }}</span></p>
                    </div>
                </div>
                <div class="modal__footer">
                    <btn-delete :isBtn="false" :view="view.translation.external_auth_cancel" :value="'grey'" :anchor="view.handler_routes.rota_office_index"></btn-delete>
                    <btn-delete :isBtn="true" :view="view.translation.label_delete_account" :value="'red'" :propFunction="deleteAccount"></btn-delete>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "delete-account-new",
    props: ["view"],
    data() {
        return {
            AccountValues: this.view.account_values,
            fatherIsWhiteLabel : this.view.fatherIsWhiteLabel,
            checkedCategories: [],
            questions: null,
            outro: null,
            password: null,
            btnActive: 'lead',
            chartOptions: {
                min: 0,
                stepSize: 2
            },
            chartData: {
                months: [],
                data: []
            },
            chartFranquia: {
                data: [],
            },
            showModal: 0,
            showValues: this.view.account_values[0].data.length > 0 && this.view.account_values[1].data.length > 0 && this.view.account_values[2].data.length > 0
        };
    },

    mounted() {
        this.questions = JSON.parse(this.view.questions);
        this.getMonth()
        console.log(this.view)
    },

    methods: {

        currencySymbol (moeda) {
            var val = '$'
            switch (moeda) {
                case 'brl':
                    val = 'R$'
                    break;
                case '$':
                    val = 'R$'
                    break;
                case 'eur':
                    val = '€'
                    break;
                case 'gbp':
                    val = '£'
                    break;
                case 'czk':
                    val = 'Kč'
                    break;
                case 'inr':
                    val = '€'
                    break;
                case 'thb':
                    val = '฿'
                    break;
            }
            return val
        },

        openModal() {
			
			// avoid blank password
            if (this.password == null || this.password.length == 0) {
              alertMsg("error", this.view.translation.auth_senha_invalida);
              return;
            }

            if(this.checkedCategories.length <= 0 && !this.fatherIsWhiteLabel) {
                 alertMsg("info", this.view.translation.fill_the_inputs);
                return;
            } else {
                if (this.view.notDelet) {
                    this.showModal = 1
                } else {
                    this.showModal = 2
                }
            }
        },

        dimissComission() {
            this.showModal = 2
        },

        deleteAccount() {
            $('#form__delete').submit();
        },

        changeCraphic(btn) {
            this.btnActive = btn
        },

        getMonth() {
            for (let i = 0; i < this.view.TotalLeadsMes.length; i++) {
                this.chartData.months.push(this.view.TotalLeadsMes[i].mes)
                this.chartData.data.push(this.view.TotalLeadsMes[i].qtd)
            }
            this.chartFranquia.data.push(this.view.StatusFranquia[0].Ativo)
            this.chartFranquia.data.push(this.view.StatusFranquia[0].Pagantes)
            this.chartFranquia.data.push(this.view.StatusFranquia[0].NaoPagantes)
            this.chartFranquia.data.push(this.view.StatusFranquia[0].Deletado)
        }

    },

}
</script>
<style lang="scss" scoped>
.template__grid {
    grid-template-columns: 64.4% 34%;
    padding: 0 2%;

    display: grid;
    justify-content: space-between;
    align-items: stretch;

    .left__content {
        height: auto;
        width: auto;

        display: grid;
        grid-gap: 1.3rem 1rem;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-template-areas:
            "balance leads leads"
            "graphic graphic graphic";

        .ndata {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            font-size: 2rem;
            font-weight: 600;
            font-family: 'Muli';
        }

        .card__balance {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: space-around;

            .align__right {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;

                .mright {
                    margin-right: .5rem;
                }
            }

            .available, .requested, .paid {
                .translation {
                    font-family: 'Mulish';
                    font-size: 1.4rem;
                    color: #AEAEAE;
                    margin-top: .5rem;
                }
            }

            .available {
                .balance {
                    span {
                        font-family: 'Lato';
                        font-weight: 700;
                        color: #156CDD;
                        font-size: 2.2rem;
                    }
                    .symbol {
                        font-size: 1.5rem;
                    }
                }
            }

            .requested {
                .balance {
                    span {
                        font-family: 'Lato';
                        font-weight: 600;
                        color: #05CD99;
                        font-size: 1.8rem;
                    }
                    .symbol {
                        font-size: 1.3rem;
                    }
                }
            }

            .paid {
                .balance {
                    span {
                        font-family: 'Lato';
                        font-weight: 600;
                        color: #EF4411;
                        font-size: 1.6rem;
                    }
                    .symbol {
                        font-size: 1.3rem;
                    }
                }
            }

            hr {
                width: 100%;
            }
        }
    }
    .iswl{
        display: flex !important;
        flex-direction: column;
        gap: 1em;
        align-items: center;
        .msg__delete,
        .select__delete{
            width: 60%;
        }
    }

    .right__content {
        height: auto;
        width: auto;

        display: grid;
        grid-gap: 1.3rem;
        grid-template-columns: 1fr;
        grid-template-rows: 2fr 7fr;

        .card__structure {
            max-width: 800px;
        }

        .msg__delete{
        }

        .select__delete{
        }
    }

    .card__content {
        height: 100%;
        width: 100%;
    }

    .balance, .leads, .graphic,
    .msg__delete, .select__delete{

        .card__structure{
            height: 100%;
            padding: 1.5rem;

            .text__structure {
                display: flex;
                align-items: center;
                justify-content: center;

                .no__values__text {
                    font-size: 2rem;
                    font-weight: 600;
                    font-family: 'Muli';
                }
            }

            .component_align_center {
                display: flex;
                align-items: center;

                height: 100%;

                .title_component {
                    font-size: 1.2rem;
                    font-weight: 500;
                    font-family: 'Lato';

                    padding: 0 1rem;
                }
            }

            .component_form {
                padding: .5rem 1rem;

                .title_form {
                    font-size: 2rem;
                    font-weight: 600;
                    font-family: 'Muli';
                    text-align: center;

                    margin-bottom: 2rem;
                }

                .input_another {
                    display: flex;
                    flex-direction: column;
                    margin: 1.5rem 1rem 1rem;

                    span {
                        font-size: 19px;
                        font-family: Mulish;
                        font-style: normal;
                        font-weight: normal;

                        margin-bottom: .3rem;
                    }
                    input, textarea {
                        min-height: 2.3rem;
                        width: 100%;
                        border: 2px solid #AEAEAE;
                        border-radius: 10px;

                        padding: 0 .5rem;
                    }
                    input:focus {
                        border: 2px solid #2196F3 !important;
                    }
                }

                .btn_form_structure {
                    display: inline-flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    padding: 0 1rem;
                    margin-top: .8rem;
                }
            }

            .top_total_lead {
                width: 100%;
                height: 100%;

                display: flex;
                flex-direction: column;

                .lead_component {
                    height: 15%;

                    display: inline-flex;
                    align-items: flex-end;
                    justify-content: flex-end;
                    padding-right: 3rem;

                    .total_leads_label, .total_leads {
                        font-family: 'Lato';
                    }

                    .total_leads_label {
                        font-size: 2rem;
                        font-weight: 500;

                        color: #333333;
                        margin-right: 1rem;
                    }
                    .total_leads {
                        font-size: 3rem;
                        font-weight: bold;

                        color: #156CDD;
                    }
                }

                .carousel {
                    height: 85%;
                    padding: 2.5rem 2rem 2rem 2rem;

                    .card_peopple {
                        width: 6rem;
                        height: 7.5rem;
                        margin: 3%;
                        //border: 1px solid green;

                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: auto;
                            height: auto;
                            max-width: 5rem;
                            border-radius: 50%;
                        }
                        span {
                            margin: .5rem 0;

                            font-size: 1rem;
                            font-family: 'Muli';
                        }
                    }

                }
            }
        }
    }
}

@media only screen and (max-width: 1365px) {
    .template__grid {
        grid-template-columns: 100%;
        grid-template-rows: auto;
        grid-gap: 1rem;

        padding: 0 6% !important;

        .right__content {
            .card__structure {
                max-width: none !important;
            }
        }
    }
    .card__structure {
        display: flex;
        align-items: center;
        justify-content: center;

        max-width: none !important;
    }
}
@media only screen and (max-width: 1200px) {
    .template__grid {
        grid-template-columns: 100%;
        grid-template-rows: auto;
        grid-gap: 1rem;

        padding: 0 !important;
    }
    .card__structure {
        max-width: available !important;
    }
    .iswl{
        .msg__delete,
        .select__delete{
            width: 100% !important;
        }
    }
}
@media only screen and (max-width: 766px) {
    .left__content {
        grid-template-rows: 1fr !important;
        grid-template-areas:
            "balance leads leads";
    }
    .graphic {
        display: none;
    }
    .second__modal {
        width: 403px !important;
        height: 880px !important;
    }
}
@media only screen and (max-width: 610px) {
    .left__content {
        grid-template-rows: 1fr 1fr !important;
        grid-template-areas:
            "balance balance balance"
            "leads leads leads" !important;
    }
    .graphic {
        display: none;
    }
    .btn_form_structure{
        flex-wrap: wrap;
        justify-content: center !important;
        gap: 1em;
    }
}

.modal__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 98;
    background-color: rgba(0, 0, 0, 0.3);

    display: flex;
    justify-content: center;

    .modal__structure {
        position: absolute;
        width: 603px;
        height: 400px;
        top: 50%;
        transform: translateY(-85%);

        z-index: 100;
        background: #FFFFFF;
        border-radius: 4px;

        display: flex;
        flex-direction: column;
        padding: 2rem;

        &.second__modal {
            height: 680px;
            transform: translateY(-60%);

            .modal__header {
                min-height: 10%;

                .title__text {
                    font-family: 'Lato';
                    font-weight: bold;
                    font-size: 1.6rem;
                    line-height: 28px;
                    color: #EF4411;
                }
            }
            .modal__body {
                min-height: 72%;
            }
            .modal__footer {
                min-height: 18%;
            }
        }


        .modal__header {
            width: 100%;
            height: auto;
            min-height: 25%;

            display: flex;
            align-items: center;
            justify-content: center;

            .atention__text {
                font-family: 'Lato';
                font-weight: bold;
                font-size: 2.5rem;
                line-height: 38px;
                color: #EF4411;
            }
        }

        .modal__body {
            width: 100%;
            height: auto;
            min-height: 45%;

            display: flex;
            flex-direction: column;
            justify-content: center;


            li {
                list-style: disc;
                margin: .5rem 0 0 2rem;

                ._text {
                    text-align: left;
                }
            }
            p {
                text-align: justify;
            }
            ._text {
                font-family: 'Muli';
                font-size: 1.1rem;
                line-height: 18px;
                text-align: center;

                color: #333333;
            }
            .first_text {
                padding-top: 1rem;
            }
        }

        .modal__footer {
            width: 100%;
            height: auto;
            min-height: 30%;

            display: inline-flex;
            align-items: center;
            justify-content: space-around;
        }
    }
}

.balance{
    grid-area: balance;
}

.leads{
    grid-area: leads;
}

.graphic{
    grid-area: graphic;

    .card__structure {
        padding: 0 !important;

        display: flex;
        flex-direction: column;

        .option__graphic {
            width: 100%;
            height: 18%;

            display: inline-flex;

            .btn_select_graphic {
                width: 12rem;
                height: 100%;

                background-color: transparent;
                border: 0;
                margin: 0 !important;

                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;

                &.lead, &.franchise {

                    .underline {
                        background-color: #0a97ff;
                    }
                }

                .text {
                    font-family: 'Muli';
                    font-size: 1.1rem;
                    font-weight: 700;
                    line-height: 19px;
                    color: #333333;
                    margin-bottom: 1rem;
                }

                .underline {
                    width: 100%;
                    height: 2px;
                    background-color: rgba(104, 118, 140, 0.5);
                }
            }
        }
        .graphics__structure {
            width: 100%;
            height: 82%;
        }
    }
}

.container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;

    font-size: 19px;
    font-family: 'Muli';
    font-style: normal;
    font-weight: normal;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: transparent;

    border-radius: 50%;
    border: 2px solid #59616a;
}

.container input:checked ~ .checkmark {
    background-color: #2196F3;
    border: 2px solid #2196F3;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.container input:checked ~ .checkmark:after {
    display: block;
}

.container .checkmark:after {
    left: 6px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/delete-account/index.vue